import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ServerlessFunctionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ServerlessFunction",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M18.71 4.27c0-.66-.64-1.24-2.13-1.24-1.69.16-3.26.94-4.41 2.2a9.15 9.15 0 0 0-2.51 4.89H7.93l-.86 1.1.13.3h2.2c-.47 2.98-.88 5.41-1.52 9.16C7.13 25.17 7 27 5.84 27c-.86-.19-1.64-.63-2.27-1.24-.13-.11-.3-.11-.52.06a2.77 2.77 0 0 0-1.07 1.78c-.06.72.86 1.38 1.91 1.38 1.14-.12 2.22-.6 3.06-1.38 1.91-1.54 3.48-3.21 4.41-7.71.72-3.61 1.05-5.87 1.46-8.36.5 0 2.09-.11 2.54-.17l.61-1.21H13c.79-5.22 1.29-5.51 1.93-5.51s1.19.5 1.96 1.41c.24.28.44.22.72.08.58-.46.97-1.13 1.09-1.86ZM27.41 19.58l-2.46-3.84c.89-1.18 1.49-1.92 1.86-2.38.6-.95 1.65-1.51 2.78-1.49V11h-4.75v.87c1.02.15 1.16.41.83 1s-.77 1.2-1.31 1.94l-1.24-1.94c-.36-.59-.19-.83.66-1V11h-6.1v.87c1.39.18 1.64.46 2.41 1.66l2.2 3.61c-.76 1.1-1.45 2.03-2.07 2.76-.66.9-1.67 1.48-2.79 1.59v.87h4.86v-.87c-1.1-.18-1.17-.53-.76-1.26s.89-1.4 1.38-2.09l1.29 2.2c.45.77.45 1.02-.62 1.2v.87H30v-.87c-1.16-.14-2.14-.9-2.59-1.97Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.52 10.62a1.14 1.14 0 0 0-1.62 0l-4.58 4.58-1.19-2.06c-1.03-1.76-2.92-2.86-4.95-2.86h-4.07l1.06-3.96c.64-2.38 2.8-4.04 5.27-4.04h3.81c.63 0 1.14-.51 1.14-1.15S24.89 0 24.26 0h-3.81a7.76 7.76 0 0 0-7.49 5.73l-1.22 4.55H7.99a1.15 1.15 0 0 0 0 2.3h3.14L7.62 25.66a5.45 5.45 0 0 1-5.27 4.04H1.14a1.14 1.14 0 1 0 .01 2.28h1.21c3.51 0 6.59-2.36 7.49-5.74l3.66-13.67h4.68c1.22 0 2.35.66 2.97 1.72l1.49 2.59-5.17 5.17a1.14 1.14 0 0 0 .81 1.95c.29 0 .59-.11.81-.33l4.74-4.74 2.6 4.5c.21.37.6.57.99.57.19 0 .39-.05.57-.15.55-.32.73-1.02.42-1.56l-2.91-5.03 5.02-5.02c.45-.45.45-1.17 0-1.62Z"
      })
    })
  }));
};
ServerlessFunctionIcon.displayName = 'ServerlessFunctionIcon';